<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module ref="fieldSelectModule" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :field-required="true" show-all />

    <!-- 교육내용 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>{{ isPrint ? '교육구분' : '교육구분(필수)' }}</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.education_type"
            @select="changeTarget1"
            :options="diff"
          />
        </div>
        <div v-if="!!form.education_type && 1 < diff[form.education_type.index].child.length" class="writeGridLineItem">
          <div>대상(작업명)</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.target_work"
            :options="diff[form.education_type.index].child"
            placeholder="1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)"
            @select="changeTarget2"
          />
        </div>
        <div>
          <div>{{ isPrint ? '교육명' : '교육명(필수)' }}</div>
          <ml-input v-model="form.education_name" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>{{ isPrint ? '교육일' : '교육일(필수)' }}</div>
          <date-selector v-model="form.education_date" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육시간</div>
          <div class="time">
            <time-selector v-model="form.education_start_time" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.education_end_time" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>교육장소</div>
          <ml-input v-model="form.education_location" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>교육 실시자 성명</div>
          <ml-input v-model="form.instructor_full_name" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 실시자 소속</div>
          <ml-input v-model="form.instructor_affiliation" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 실시자 직책</div>
          <ml-input v-model="form.instructor_position" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 대상</div>
          <ml-input v-model="form.education_target" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 실시 인원</div>
          <comma-input v-model="form.participants_attended" type="number" :readonly="board.readonly" placeholder="입력해 주세요" />
          <p>명</p>
        </div>
        <div>
          <div>교육 미실시 인원</div>
          <comma-input v-model="form.participants_not_attended" type="number" :readonly="board.readonly" />
          <p>명</p>
        </div>
        <div class="writeGridLineItem">
          <div>교육내용</div>
          <ml-textarea rows="5" v-model="form.education_content" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>근로자 의견</div>
          <ml-textarea rows="5" v-model="form.worker_opinion" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 참석자 명단 -->
    <table-custom
      :default-size="0"
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        /*{ id: 'employee_id', title: 'ID(사번)', type: 'fixed-text', placeholder: '' },*/
        { id: '부서명_과', title: '부서명', type: 'fixed-text', placeholder: '' },
        { id: 'com_name', title: '팀명', type: 'fixed-text', placeholder: '' },
        { id: 'employment_type', title: '직종', type: 'fixed-text', placeholder: '' },
        { id: 'full_name', title: '이름', type: 'fixed-text', placeholder: '' },
        { id: 'note', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="employeeList"
      class="mt-4"
      :button-add-name="'참석자 등록'"
      :custom-add-handler="true"
      :custom-remove-handler="true"
      @add-row="onClickAddEmployee"
      @remove-row="onClickRemoveEmployee"
    />

    <!-- 확인자 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer">
        <div>
          <div>담당</div>
          <ml-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>검토</div>
          <ml-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>전결</div>
          <ml-input v-model="form.sign3.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign3.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="교육 사진" placeholder="신축현장 점검" :show-footer-input="false" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <popup-search-employee-checkbox v-model="showPopup" :initSelectedEmployees="JSON.parse(JSON.stringify(employeeList))" @handleClickSelect="handleEmployeeSelect" />
  </div>
  <print v-else :form="form" :employeeList="employeeList" />
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Print from "./Print.vue";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { valueDisasters } from "@/util/DisasterDataUtil";
import TableCustom from "@/components/TableCustom.vue";
import diffData from "./DiffData";
import SignField from "@/components/SignField.vue";
import PopupSearchEmployeeCheckbox from "@/popup/PopupSearchEmployeeCheckbox.vue";
import moment from "moment";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    PopupSearchEmployeeCheckbox,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      showPopup: false,
      disasterTypes: [{ text: "전체선택", value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: "현장명" },
        { value: "inputD_1", text: "재해일시" },
        { value: "inputD_3", text: "발생형태" },
        { value: "stdInfo.department", text: "소속명" },
        { value: "stdInfo.com_name", text: "부서명" },
        { value: "stdInfo.writer_name", text: "작성자" },
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // 종사자 정보
      employeeList: [],
      loadEmployee: false,

      // =============== FORM ===============
      diff: JSON.parse(JSON.stringify(diffData)),
      form: {
        stdInfo: {},

        education_type: null,
        target_work: null,

        education_name: "",
        education_date: "",
        education_start_time: "",
        education_end_time: "",
        education_location: "",
        instructor_full_name: "",
        instructor_affiliation: "",
        instructor_position: "",
        education_target: "",
        participants_attended: "",
        participants_not_attended: "",
        education_content: "",
        worker_opinion: "",
        disaster_type_direct_input: "",
        // 교육 시간
        educationHours: 0,

        selectedEmployees: [],
        photoList: [],
        fileList: [],
        signatureList: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        disasters: "",
      },

      // 아래 두 속성 추가
      employeePromises: {}, // 진행 중인 요청을 저장
      employeeCache: {}, // 캐시된 결과를 저장
      employeeCacheExpiry: {}, // 캐시 만료 시간을 저장
    };
  },
  computed: {
    // computed
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
        this.syncDiffSelection();
      },
    },
    /**
     * 종사자 목록이 갱신되면, form 내에는 ID 값만 추출해서 보관한다.
     * 종사자 정보 중에는 암호화되어 있는 데이터가 있기 때문에, 모든 정보를 보관하면 보안상 문제가 발생할 수 있다.
     * {id: 1, note: '비고'} 형식으로 변환한다
     */
    employeeList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.selectedEmployees = value.map((item) => {
          return { id: item.id, note: item.note };
        });
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          안전보건교육_현장명: [],
          안전보건교육_재해형태: [],
          안전보건교육_교육구분: [],
          안전보건교육_현장별교육구분: [],
          안전보건교육_현장별재해형태: [],
        };

        value.summary["안전보건교육_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        if (this.form.education_type) {
          value.summary["안전보건교육_교육구분"].push({
            [this.form.education_type.value]: 1,
          });

          value.summary["안전보건교육_현장별교육구분"].push({
            [`${this.form.stdInfo.field_name}_${this.form.education_type.value}`]: 1,
          });
        }

        // 문서에는 종사자 ID 값만 보관되어 있다.
        // ID 값에 해당하는 종사자 목록을 불러오도록 한다
        this.initEmployeeList();

        // 교육 시간을 갱신한다
        this.updateEducationHours();

        this.$emit("input", value);
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
    this.syncDiffSelection();
  },
  methods: {
    /**
     * 문서를 불러왔을 때 사용된다.
     * 문서에는 보안을 위해서, 종사자 ID 값만 보관되어 있다.
     * ID 값에 해당하는 종사자 목록을 불러오도록 한다
     */
    initEmployeeList() {
      // 문서에서 불러온 종사자 정보(id)가 있지만, 종사자 목록이 비어있는 경우
      if (this.form.selectedEmployees && this.form.selectedEmployees.length > 0 && this.employeeList.length === 0) {
        const page = 1;
        const perPage = this.form.selectedEmployees.length;
        const projectId = this.projectId;
        const ids = this.form.selectedEmployees.map((item) => item.id);

        const payload = { projectId, page, perPage, ids };
        const cacheKey = JSON.stringify(payload);
        const now = Date.now();

        // 캐시된 결과가 있고, 아직 유효하다면 사용
        if (this.employeeCache[cacheKey] && this.employeeCacheExpiry[cacheKey] > now) {
          this.processEmployeeData(this.employeeCache[cacheKey]);
          return;
        }

        // 이미 진행 중인 요청이 있다면 해당 Promise 반환
        if (this.employeePromises[cacheKey]) {
          // 진행 중인 요청의 결과를 처리
          this.employeePromises[cacheKey].then(result => {
            if (result && result.data) {
              this.processEmployeeData(result.data);
            }
          });
          return;
        }

        // 새로운 요청 생성
        this.loadEmployee = true;

        // Promise를 생성하고 저장
        this.employeePromises[cacheKey] = this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload);

        this.employeePromises[cacheKey]
          .then((result) => {
            this.loadEmployee = false;
            if (result && result.data) {
              // 캐시에 결과 저장 (1초 동안 유효)
              this.employeeCache[cacheKey] = result.data;
              this.employeeCacheExpiry[cacheKey] = Date.now() + 1000; // 1초 후 만료

              // 데이터 처리
              this.processEmployeeData(result.data);
            }
          })
          .catch(error => {
            console.error('종사자 정보 로드 오류:', error);
            this.loadEmployee = false;
          })
          .finally(() => {
            // 요청이 완료되면 Promise 캐시에서 제거
            setTimeout(() => {
              this.employeePromises[cacheKey] = null;
            }, 0);
          });
      }
    },

    // 종사자 데이터 처리 로직을 별도 메소드로 분리
    processEmployeeData(data) {
      // 깊은 복사를 통해 Vuex 상태와 분리
      const employeeData = JSON.parse(JSON.stringify(data));

      // 깊은 복사본을 수정
      for (const item of this.form.selectedEmployees) {
        const index = employeeData.findIndex((employee) => employee.id === item.id);
        if (index > -1) {
          employeeData[index].com_name = employeeData[index].company.com_name;
          employeeData[index].note = item.note;
        }
      }

      // 로컬 상태 업데이트
      this.employeeList = employeeData;
    },

    // education_start_time 시각(10:00:00)으로부터 education_end_time 시각(16:00:00)까지 경과된 시간을 form.educationHours 에 저장한다
    updateEducationHours() {
      if (this.form.education_start_time && this.form.education_end_time) {
        const start = moment(this.form.education_start_time, "HH:mm:ss");
        const end = moment(this.form.education_end_time, "HH:mm:ss");
        const duration = moment.duration(end.diff(start));
        const hours = duration.asHours();

        // 만약 hours 값이 0보다 작다면 0으로 설정한다
        this.form.educationHours = hours < 0 ? 0 : hours;
      }
    },

    // ======================= FORM =======================
    // 저장된 교육구분/대상(작업명)은 목록 index 기준으로 복원되므로,
    // 목록이 개정되어도 key(우선) 또는 이름(value) 기준으로 index를 다시 맞춘다
    syncDiffSelection() {
      const savedType = this.form.education_type;
      if (!savedType || (!savedType.key && !savedType.value)) return;
      let typeIndex = savedType.key ? this.diff.findIndex((item) => item.key === savedType.key) : -1;
      if (typeIndex < 0) typeIndex = this.diff.findIndex((item) => item.value === savedType.value);
      if (typeIndex > -1 && typeIndex !== savedType.index) {
        this.form.education_type = { ...savedType, index: typeIndex };
      }
      const savedWork = this.form.target_work;
      if (typeIndex < 0 || !savedWork || (!savedWork.key && !savedWork.value)) return;
      const children = this.diff[typeIndex].child;
      let workIndex = savedWork.key ? children.findIndex((item) => item.key === savedWork.key) : -1;
      if (workIndex < 0) workIndex = children.findIndex((item) => item.value === savedWork.value);
      if (workIndex < 0) {
        // 항목 명칭이 개정된 경우 번호 접두사(예: "35.")로 폴백 매칭
        const prefix = (String(savedWork.value).match(/^\d+\./) || [])[0];
        if (prefix) workIndex = children.findIndex((item) => String(item.value).startsWith(prefix));
      }
      if (workIndex < 0) {
        // 한글 접두사(예: "가. ")·공백 제거 후 폴백 매칭 (구 안전보건관리책임자 교육 하위 항목 등)
        const normalize = (s) => String(s).replace(/^[가-힣]\.\s*/, "").replace(/\s+/g, "");
        // 명칭 자체가 개정된 항목의 구명칭 → 신명칭 별칭
        const legacyAlias = { "안전관리자및안전관리전문기관종사자": "안전관리책임자및안전관리전문기관종사자" };
        let key = normalize(savedWork.value);
        if (legacyAlias[key]) key = legacyAlias[key];
        workIndex = children.findIndex((item) => normalize(item.value) === key);
      }
      if (workIndex > -1 && workIndex !== savedWork.index) {
        this.form.target_work = { ...savedWork, index: workIndex };
      }
    },
    changeTarget1(selected) {
      // v-model(form.education_type) 갱신보다 select 이벤트가 먼저 도착할 수 있으므로, 전달된 선택값을 직접 사용한다
      const target = selected || this.form.education_type;
      if (!target) return;
      if (1 === this.diff[target.index].child.length) {
        this.form.education_content = this.diff[target.index].child[0].textarea;
      } else {
        this.form.target_work = null;
        this.form.education_content = "";
      }
    },
    // changeTarget1 는 문서를 호출하면 한번은 호출 되므로,
    // form.target_work 초기화 하는 작업을 별도로 수행한다
    changeTarget2(selected) {
      const work = selected || this.form.target_work;
      if (!!this.form.education_type && !!work) this.form.education_content = this.diff[this.form.education_type.index].child[work.index].textarea;
    },
    onClickAddEmployee() {
      this.showPopup = true;
    },
    onClickRemoveEmployee(checkData) {
      // checkData의 배열에 있는 값과 this.employeeList의 id가 같은 것이 제거되도록 this.employeeList를 수정한다
      this.employeeList = this.employeeList.filter((item) => !checkData.includes(item.id));
    },
    handleEmployeeSelect(datas) {
      // 깊은 복사로 데이터 분리
      const dataCopy = JSON.parse(JSON.stringify(datas));

      if (this.employeeList.length > 0) {
        if (dataCopy.length > 0) {
          const adds = dataCopy.filter((v) => {
            for (const emp of this.employeeList) {
              if (emp.id === v.id) {
                return false;
              }
            }
            return true;
          });

          // 새 배열 생성 후 복사
          const newEmployeeList = [...this.employeeList];
          newEmployeeList.push(...adds.map((item) => {
            return {
              id: item.id,
              부서명_과: item.부서명_과,
              employee_id: item.employee_id,
              com_name: item.com_name ? item.com_name : item.company.com_name,
              field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
              employment_type: item.employment_type,
              full_name: item.full_name,
            };
          }));

          this.employeeList = newEmployeeList;
        }
      } else {
        this.employeeList = dataCopy.map((item) => {
          return {
            id: item.id,
            부서명_과: item.부서명_과,
            employee_id: item.employee_id,
            com_name: item.com_name ? item.com_name : item.company.com_name,
            field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
            employment_type: item.employment_type,
            full_name: item.full_name,
          };
        });
      }

      // 중복 제거 로직 수정 (문제 있는 코드)
      const newList = JSON.parse(JSON.stringify(this.employeeList));
      // indexOf 사용 시 객체 비교가 제대로 되지 않아 id로만 필터링
      this.employeeList = newList.filter((item, index, self) => index === self.findIndex(t => t.id === item.id)
      );

      this.form.participants_attended = this.employeeList.length;
    },

    // 저장 전 필수값 검증. 통과하면 true, 빠진 항목이 있으면 첫 번째 항목을 알리고 false 를 반환한다
    validate() {
      if (!this.form.stdInfo || !this.form.stdInfo.field_name) {
        const fieldTitle = (this.$refs.fieldSelectModule && this.$refs.fieldSelectModule.fieldTitle) || "사업장명";
        UiUtil.alertDialog(`${fieldTitle}을(를) 반드시 입력해야 합니다`);
        return false;
      }
      if (!this.form.education_type) {
        UiUtil.alertDialog("교육구분을 반드시 입력해야 합니다");
        return false;
      }
      if (!this.form.education_name || !String(this.form.education_name).trim()) {
        UiUtil.alertDialog("교육명을 반드시 입력해야 합니다");
        return false;
      }
      if (!this.form.education_date) {
        UiUtil.alertDialog("교육일을 반드시 입력해야 합니다");
        return false;
      }
      return true;
    },
  },
};
</script>
